import _get from "lodash.get";
export function caculateTempPrice(bill) {
  let tempPrice = 0;
  const billItems = _get(bill, "item", []);
  billItems.forEach((item) => {
    tempPrice += item.price * item.quantity;
  });
  return tempPrice;
}

export function caculateTotalPrice(bill) {
  const { voucher, discount, tax = 0 } = bill;
  let tempPrice = caculateTempPrice(bill);
  let discountValue = 0;
  if (discount) {
    discountValue =
      discount.type === "percent" ? tempPrice * discount.value : discount.value;
  }
  let voucherDiscountValue = 0;
  if (voucher) {
    voucherDiscountValue =
      voucher.type === "percent"
        ? tempPrice * voucher.discount
        : voucher.discount;
  }
  let totalDiscountValue = discountValue + voucherDiscountValue;

  if (discount != null && voucher != null && discount.canUseVoucher == 0) {
    totalDiscountValue = totalDiscountValue - discountValue;
    discountValue = 0.0;
  }

  const totalPrice = Math.max(
    tempPrice + tax * tempPrice - totalDiscountValue,
    0
  );
  return totalPrice;
}

export const caculateDiscount = (bill) => {
  const { discount } = bill;
  let discountValue = 0;
  let tempPrice = caculateTempPrice(bill);
  if (discount) {
    discountValue =
      discount.type === "percent" ? tempPrice * discount.value : discount.value;
  }
  return discountValue;
};
export const caculateVoucher = (bill) => {
  const { voucher } = bill;
  let voucherDiscountValue = 0;
  let tempPrice = caculateTempPrice(bill);
  if (voucher) {
    voucherDiscountValue =
      voucher.type === "percent"
        ? tempPrice * voucher.discount
        : voucher.discount;
  }
  return voucherDiscountValue;
};
export const caculateTax = (bill) => {
  const { tax = 0 } = bill;
  console.log(bill);
  let tempPrice = caculateTempPrice(bill);
  return tax * tempPrice;
};
export const caclTotalPayment = (bill) => {
  const { payment = [] } = bill;
  const totalPrice = caculateTotalPrice(bill);
  let totalPayment = 0;
  payment.forEach((item) => {
    let lastReceived = item.moneyReceived - item.moneyChange;
    totalPayment += lastReceived;
  });
  const unpaidMoney = Math.max(totalPrice - totalPayment, 0);
  return { totalPayment, unpaidMoney };
};
